import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-video-help',
  templateUrl: './video-help.component.html',
  styleUrls: ['./video-help.component.scss'],
})
export class VideoHelpComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
